// External Imports
import { createSelector } from 'reselect';

// Internal Imports
import { CONTENT_ITEM_SINGLE } from '../config/types/path.mjs';
import { getPathType } from './getMatch.mjs';

// Local Functions
const getIsArticlePage = createSelector(
  getPathType,
  (pathType) => pathType === CONTENT_ITEM_SINGLE,
);

// Module Exports
export { getIsArticlePage };
